"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nano = require("./nano");
var _shared = require("./shared");
var _variables = require("./variables");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fullSizeMinusPadding = 'calc(100% - 10px)';
var _default = exports["default"] = (0, _nano.sheet)({
  multiSelect: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: '100px',
    minHeight: '25px',
    border: 'none'
  },
  multiSelect__display: {
    '&.has-float-label input:placeholder-shown:not(:focus) + :not(.input-has-content)': {
      top: '0.75em'
    },
    '&, & input': {
      cursor: 'pointer'
    }
  },
  multiSelect__dropdown: _objectSpread({
    position: 'absolute',
    top: fullSizeMinusPadding,
    display: 'none',
    width: fullSizeMinusPadding,
    zIndex: _variables.zIndexes.get('popover')
  }, _shared.standardShadow),
  multiSelect__dropdown_open: {
    display: 'flex'
  },
  multiSelect__list: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: "300px",
    padding: '5px',
    margin: '5px 0',
    listStyleType: 'none',
    overflow: 'auto',
    '& li': {
      flexBasis: '100%'
    }
  },
  separator: {
    height: '1px',
    borderBottom: '1px solid',
    opacity: 0.2
  }
});